// import { allStrings } from "../i18n/langs";
export default {
  state: {
    lang: localStorage.getItem("lang") || "en",
  },
  mutations: {
    setLanguage(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
    setLanguage(context, lang) {
      // if (Object.keys(allStrings).includes(lang))
      localStorage.setItem("lang", lang);
      //context.dispatch('clearCache')
      context.commit("setLanguage", lang);
    },
  },
};
